{
  "nav": {
    "stats": "Tilastot",
    "registerCatch": "Rekisteröi saalis",
    "myCatches": "Omat saaliit",
    "myFiskekort": "Omat kalastusluvat",
    "myBookings": "Omat varaukset",
    "profile": "Profiili",
    "login": "Kirjaudu sisään",
    "logout": "Kirjaudu ulos",
    "admin": "Admin",
    "valdAdmin": "Vald-hallinta",
    "riverAdmin": "Joki-hallinta",
    "history": "Historia",
    "buyFiskekort": "Osta kalastuskortti",
    "registerLink": "Luo tili",
    "loggFiskedag": "Kirjaa kalastuspäivä",
    "contact": "Ota yhteyttä",
    "language": "Kieli",
    "fiskeHer": "Kalastaa täällä",
    "sectionFishing": "Kalastus",
    "sectionExplore": "Tutustu",
    "sectionAccount": "Oma tili",
    "sectionManagement": "Hallinta",
    "sectionForOwners": "Omistajille",
    "sellFiskekort": "Myy kalastuslupia",
    "riverOwnersAssoc": "Joenomistajien yhdistys",
    "photoContest": "Valokuvakilpailu",
    "adminPhotoContest": "Valokuvakilpailu (admin)",
    "menu": "Valikko",
    "openMenu": "Avaa valikko",
    "closeMenu": "Sulje valikko",
    "privacy": "Tietosuoja",
    "rivers": "Joet ja vuokra-alueet"
  },
  "stats": {
    "title": "Saalistilastot",
    "filterYear": "Vuosi",
    "filterMonth": "Kuukausi",
    "filterWeek": "Viikko",
    "filterDay": "Päivä",
    "totalCatches": "Saaliit yhteensä",
    "totalWeight": "Kokonaispaino",
    "avgWeight": "Keskipaino",
    "biggestFish": "Suurin kala",
    "released": "Vapautettu",
    "recentCatches": "Viimeisimmät saaliit",
    "noData": "Ei saaliita valitulla ajanjaksolla",
    "allRivers": "Kaikki joet",
    "allValds": "Kaikki valdit",
    "viewVald": "Näytä vald-sivu →",
    "uniqueAnglers": "Kalastajat",
    "cpue": "Saaliit per kalastaja",
    "registerCatchDesc": "Kirjaa pyytämäsi kala lajin, painon ja pituuden kanssa. Nimeäsi ei näytetä julkisesti oletuksena.",
    "startFishingDesc": "Paina, kun aloitat kalastuksen, ja ”Kalastus päättynyt”, kun lopetat. Tallennamme vain ajankohdat, emme koskaan sijaintiasi.",
    "intro": "Lakseborsen on avoin <b>lohipörssi</b>, joka kerää reaaliajassa <b>lohitilastoja</b> rekisteröidyistä norjalaisista lohi- ja meritaimenjoista. Katso ajantasaiset saaliiluvut vuodelta <b>{{year}}</b> — saaliiden määrä, kokonaispaino, keskipaino ja suurin kala jokea tai koskialuetta kohden. Siirry <history>saalishistoriaan</history>, jos haluat nähdä kaudet vuoteen 2014 asti."
  },
  "catch": {
    "title": "Rekisteröi saalis",
    "vald": "Vald (kalastusalue)",
    "selectVald": "Valitse vald…",
    "fishType": "Kalalaji",
    "weight": "Paino (kg)",
    "weightKg": "Paino (kg)",
    "length": "Pituus (cm)",
    "lengthCm": "Pituus (cm)",
    "date": "Päivämäärä",
    "time": "Kellonaika",
    "gear": "Väline",
    "photo": "Kuva (valinnainen)",
    "photoUploadFailed": "Kuvan lataus epäonnistui",
    "released": "Vapautettu",
    "fromBoat": "Veneestä",
    "sex": "Sukupuoli (valinnainen)",
    "sexTypes": {
      "hann": "Koiras",
      "hunn": "Naaras"
    },
    "seaLice": "Lohitäi",
    "fisher": "Kalastaja",
    "roer": "Soutaja",
    "onBehalf": {
      "question": "Kenelle tämä saalis on?",
      "self": "Minulle itselleni",
      "other": "Toiselle kalastajalle",
      "fisherName": "Kalastajan nimi",
      "fisherNamePlaceholder": "Kirjoita nimi",
      "recent": "Viimeksi käytetyt"
    },
    "conditions": "Olosuhteet saaliin hetkellä",
    "airTemp": "Ilman lämpötila",
    "precipitation": "Sademaarä",
    "windSpeed": "Tuulen nopeus",
    "waterTemp": "Veden lämpötila",
    "waterFlow": "Virtaama",
    "nveStationSource": "Lähde: {{station}}",
    "weatherPending": "Säätiedot saatavilla noin 5 päivän kuluttua",
    "submit": "Rekisteröi",
    "submitting": "Tallennetaan…",
    "success": "Saalis rekisteröity!",
    "offlineDraft": "Tallennettu paikallisesti — lähetetään automaattisesti kun olet verkossa",
    "fishTypes": {
      "laks": "Atlantin lohi",
      "brunørret": "Purotaimen",
      "sjøørret": "Meritaimen",
      "pukkellaks": "Kyttyrälohi",
      "oppdrettslaks": "Kasvatuslohi",
      "støing": "Støing",
      "røye": "Nieriä",
      "ørret": "Meritaimen"
    },
    "gearTypes": {
      "flue": "Perhokalastus",
      "wobbler": "Wobbler",
      "spinner": "Spinner",
      "sluk": "Lusikkaviehe",
      "mark_orm": "Mato / syötti",
      "rapala": "Rapala",
      "annet": "Muu"
    },
    "errors": {
      "valdRequired": "Valitse kalastusalue",
      "weightInvalid": "Paino täytyy olla välillä 0.1–100 kg",
      "lengthInvalid": "Pituus täytyy olla välillä 5–250 cm",
      "dateRequired": "Anna päivämäärä ja kellonaika",
      "fisherNameRequired": "Anna kalastajan nimi"
    },
    "fishingDayPrompt": "Kalastettu tänään ilman saalista?",
    "logFishingDay": "Kirjaa kalastuspäivä",
    "logFishingDayDone": "Kalastuspäivä kirjattu ✓",
    "edit": "Muokkaa",
    "editTitle": "Muokkaa saalista",
    "editSave": "Tallenna muutokset",
    "editSaved": "Saalis päivitetty!",
    "locate": {
      "button": "Käytä sijaintiani",
      "locating": "Etsitään sijaintia…",
      "found": "Löytyi lähin vald: {{vald}}",
      "unsupported": "Sijaintia ei tueta tässä selaimessa",
      "denied": "Sinun täytyy sallia sijainnin käyttö tätä varten",
      "failed": "Sijaintia ei saatu selville",
      "noneFound": "Lähistöllä ei ole vielä valdeja, joilla on sijaintitieto"
    },
    "photoPendingOffline": "Kuva ladataan automaattisesti, kun olet taas verkossa",
    "photoChange": "Vaihda kuva",
    "photoAdd": "Lisää kuva",
    "photoPreviewAlt": "Esikatselu",
    "fishingDayOffline": "Tallennettu paikallisesti — kirjataan automaattisesti kun olet verkossa",
    "showNamePublic": "Näytä nimeni julkisesti",
    "showNamePublicDesc": "Pois päältä oletuksena. Saalis lasketaan tilastoihin joka tapauksessa."
  },
  "bulk": {
    "title": "Rekisteröi pienet kalat (massarekisteröinti)",
    "intro": "Pyysit paljon pieniä taimenia? Rekisteröi kaikki kerralla yhden yhden sijaan.",
    "count": "Kalojen määrä",
    "countHint": "Rekisteröidään {{count}} kalaa",
    "allReleased": "Kaikki vapautettu",
    "optionalMeasurements": "Valinnaiset mitat (jätä tyhjäksi jos tuntematon)",
    "avgWeight": "Keskimääräinen paino (kg)",
    "avgLength": "Keskimääräinen pituus (cm)",
    "lengthHint": "Yleensä alle 40 cm",
    "submit": "Rekisteröi {{count}} kalaa",
    "submitting": "Rekisteröidään…",
    "success": "{{count}} kalaa rekisteröity!",
    "successDetail": "Saaliit on tallennettu ja näkyvät tilastoissa.",
    "registerMore": "Rekisteröi lisää",
    "backToForm": "Normaali rekisteröinti",
    "bulkLink": "Pyysit paljon pieniä taimenia? → Massarekisteröinti",
    "errors": {
      "countInvalid": "Määrän tulee olla 1–50"
    },
    "decreaseCount": "Vähennä",
    "increaseCount": "Lisää"
  },
  "myCatches": {
    "title": "Omat saaliit",
    "empty": "Et ole vielä rekisteröinyt yhtään saalista.",
    "registerFirst": "Rekisteröi ensimmäinen saaliisi",
    "exportCsv": "Lataa omat saaliini",
    "exportError": "Saaliiden lataus epäonnistui"
  },
  "profile": {
    "title": "Oma profiili",
    "displayName": "Nimi",
    "language": "Kieli",
    "save": "Tallenna",
    "saved": "Tallennettu!",
    "security": "Turvallisuus",
    "passkey": "Passkey (biometrinen kirjautuminen)",
    "passkeyDesc": "Kirjaudu nopeasti sormenjäljellä, kasvojentunnistuksella tai suojausavaimella.",
    "registerPasskey": "Rekisteröi passkey",
    "addPasskey": "Lisää uusi passkey",
    "passkeyDefaultLabel": "Passkey",
    "passkeyAdded": "Lisätty {{date}}",
    "deletePasskey": "Poista",
    "confirmDeletePasskey": "Poistetaanko passkey \"{{label}}\"?",
    "hideNamePublic": "Näytä saaliini nimettömästi",
    "hideNamePublicDesc": "Nimesi piilotetaan julkisista saalistilastoista. Saaliisi lasketaan silti tilastoihin.",
    "deleteAccount": "Poista tili",
    "deleteAccountDesc": "Poistaa nimesi, sähköpostisi ja muut henkilötiedot profiilistasi. Saaliisi säilytetään anonymisoituna, kuten laki edellyttää saalisraportoinnissa.",
    "confirmDeleteAccount": "Haluatko varmasti poistaa tilisi? Tätä ei voi peruuttaa.",
    "privacy": "Tietosuoja",
    "privacyDesc": "Lataa kaikki sinusta tallentamamme tiedot. Katso myös tietosuojaseloste (norjaksi).",
    "exportData": "Lataa tietoni"
  },
  "admin": {
    "title": "Hallintapaneeli",
    "totalCatches": "Saaliit yhteensä",
    "catchesThisYear": "Saaliit tänä vuonna",
    "totalFishers": "Aktiiviset kalastajat",
    "totalUsers": "Rekisteröityneet käyttäjät",
    "tabCatches": "Saaliit",
    "tabUsers": "Käyttäjät",
    "dateFrom": "Alkaen",
    "dateTo": "Päättyen",
    "allFishTypes": "Kaikki kalalajit",
    "allReleased": "Kaikki",
    "keptOnly": "Vain pidetyt",
    "releasedOnly": "Vain vapautetut",
    "applyFilters": "Suodata",
    "resetFilters": "Nollaa",
    "catchCount": "{{count}} saalista",
    "exportCsv": "Lataa CSV",
    "deleteSelected": "Poista valitut ({{count}})",
    "confirmBulkDeleteCatches": "Poistetaanko {{count}} saalis(ta)? Tätä ei voi peruuttaa.",
    "bulkDeleteDone": "{{count}} saalis(ta) poistettu.",
    "selectAllOnPage": "Valitse kaikki tällä sivulla",
    "selectRow": "Valitse rivi",
    "fisher": "Kalastaja",
    "yes": "Kyllä",
    "no": "Ei",
    "prevPage": "Edellinen",
    "nextPage": "Seuraava",
    "userName": "Nimi",
    "userEmail": "Sähköposti",
    "userRole": "Rooli",
    "userCatches": "Saaliit",
    "registered": "Rekisteröitynyt",
    "role_fisher": "Kalastaja",
    "role_admin": "Admin",
    "promote": "Tee adminiksi",
    "demote": "Poista admin",
    "tabValds": "Kalavyöhykkeet",
    "valdName": "Kalavyöhyke",
    "valdRiver": "Joki",
    "valdOwner": "Omistaja",
    "valdNoOwner": "Ei omistajaa",
    "assignOwner": "Määritä omistaja",
    "clearOwner": "Poista omistaja",
    "searchVald": "Hae vyöhykettä…",
    "searchUser": "Etsi käyttäjää (nimi tai sähköposti)…",
    "search": "Etsi",
    "select": "Valitse",
    "filterRiver": "Suodata joen mukaan",
    "allRivers": "Kaikki joet",
    "searchUsers": "Hae nimellä tai sähköpostilla…",
    "ownedValds": "Kalavesi",
    "selectVald": "Valitse kalavesi…",
    "assignVald": "Määritä kalavesi",
    "removeValdOwner": "Poista omistajuus",
    "role_river_admin": "Joki-admin",
    "promoteRiverAdmin": "Tee joki-adminiksi",
    "demoteRiverAdmin": "Poista joki-admin",
    "selectRiver": "Valitse joki…",
    "selectRiverSystem": "Valitse jokijärjestelmä…",
    "makeRiverAdmin": "Tee joki-adminiksi",
    "inviteOwner": "Kutsu killan omistaja",
    "inviteHint": "Syötä tulevan killan omistajan sähköpostiosoite.",
    "inviteEmailPlaceholder": "Omistajan sähköposti",
    "sendInvite": "Lähetä kutsu",
    "inviteSentOk": "Kutsu lähetetty osoitteeseen {{email}}",
    "inviteAssignedDirect": "{{email}} on jo käyttäjä ja hänelle myönnettiin omistajuus",
    "pendingInvite": "Odottaa: {{email}}",
    "edit": "Muokkaa",
    "riverClosed": "Väliaikaisesti suljettu",
    "riverDescription": "Kuvaus",
    "riverFishingRules": "Kalastussäännöt",
    "riverFlags": "Tila",
    "riverMain": "Pääjoki",
    "riverMunicipalities": "Kunta",
    "riverName": "Nimi",
    "riverNveId": "NVE-aseman tunnus",
    "riverNveName": "NVE-aseman nimi",
    "riverRequiresDisinfection": "Vaatii desinfioinnin",
    "riverSeason": "Kausi",
    "riverSeasonClose": "Kausi päättyy (MM-DD)",
    "riverSeasonOpen": "Kausi alkaa (MM-DD)",
    "riverSystem": "Järjestelmä",
    "searchRiver": "Hae jokea (nimi, kunta, järjestelmä)…",
    "tabRivers": "Joet"
  },
  "riverAdmin": {
    "title": "Joki-admin",
    "totalCatches": "Saaliit yhteensä",
    "catchesThisYear": "Saaliit tänä vuonna",
    "allYears": "Kaikki vuodet",
    "exportCsv": "Lataa Excel",
    "exportError": "Excel-lataus epäonnistui",
    "tabs": {
      "fangster": "Saaliit",
      "valds": "Kalastusalueet",
      "elver": "Joet",
      "meldinger": "Viestit",
      "vilkar": "Ehdot",
      "rettelser": "Korjaukset",
      "fisketrykk": "Kalastuspaine",
      "elvekort": "Elvekort"
    },
    "rivers": {
      "title": "Kausi ja sulkemiset",
      "hint": "Aseta kausipaivämäärät joelle. Väliaikainen sulkeminen näkyy kalastajille.",
      "seasonOpen": "Kausi alkaa",
      "seasonClose": "Kausi päättyy",
      "month": "Kuukausi",
      "day": "Päivä",
      "temporarilyClosed": "Väliaikaisesti suljettu",
      "temporarilyClosedHint": "Näyttää 'Väliaikaisesti suljettu' -varoituksen julkisella jokisivulla. Kalastajat voivat edelleen rekisteröidä saaliit ja ostaa kalastuskortteja.",
      "requiresDisinfection": "Vaatii desinfioinnin",
      "requiresDisinfectionHint": "Kalastajien on vahvistettava desinfiointimenetelmä luvan oston yhteydessä",
      "save": "Tallenna",
      "saved": "Tallennettu ✓",
      "fishingRules": "Kalastussäännöt (teksti, julkinen)",
      "fishingRulesPlaceholder": "Kirjoita säännöt, rajoitukset ja muut kalastajien tarvitsemat tiedot…",
      "description": "Kuvaus (näkyy julkisesti)",
      "descriptionPlaceholder": "Kirjoita lyhyt kuvaus joesta…",
      "images": "Kuvat (näkyvät jokisivulla)",
      "addPhoto": "+ Lisää kuva",
      "municipalities": "Kunta",
      "municipalitiesHint": "Näytetään SEO-metatiedoissa ja jokisivulla. Vain sivuston ylläpitäjä voi muokata.",
      "municipalitiesPlaceholder": "esim. Røyrvik, Namsskogan, Grong, Overhalla, Namsos",
      "stayGuide": "Näin majoitut täällä (teksti, näkyy julkisesti)",
      "stayGuidePlaceholder": "Vinkkejä kalastajien majoittumiseen: lähin taajama, mitä kannattaa varata ajoissa, ruokapaikat, välineiden vuokraus…",
      "nearbyPlaces": "Hotellit ja ruokapaikat lähistöllä",
      "placeName": "Nimi",
      "placeDistance": "Etäisyys, esim. ”5 min Formofossista”",
      "placeDescription": "Lyhyt kuvaus",
      "addPlace": "+ Lisää paikka",
      "seasonEvents": "Mitä kauden aikana tapahtuu (tapahtumat)",
      "eventTitle": "Otsikko, esim. ”Lohen päivä”",
      "eventStart": "Alkamispäivä",
      "eventEnd": "Päättymispäivä (valinnainen)",
      "eventDescription": "Lyhyt kuvaus",
      "addEvent": "+ Lisää tapahtuma",
      "placeLat": "Leveysaste (valinnainen)",
      "placeLon": "Pituusaste (valinnainen)",
      "placeHighlight": "Sponsorin teksti (näytetään sponsoroituna sisältönä)",
      "placeTags": "Palvelut",
      "placeSponsor": "Tukee jokea (sponsori)",
      "placePick": "Suositus? Kerro miksi (näytetään tekstillä ”Jokiosakaskunnan suosittelema”)",
      "placeLogo": "Logo (valinnainen)",
      "sponsorReport": "Sponsoriraportti",
      "sponsorReportMonth": "Kuukausi",
      "sponsorReportLinks": "Linkin klikkaukset",
      "sponsorReportMap": "Näytä kartalla",
      "sponsorReportCopy": "Kopioi teksti",
      "sponsorReportCopied": "Kopioitu",
      "sponsorReportHint": "Laskee sponsorilinkin ja ”Näytä kartalla” -toiminnon klikkaukset. Henkilötietoja ei tallenneta.",
      "sponsorReportText": "{{name}}: kuussa {{month}} linkkiäsi klikattiin {{link}} kertaa ja ”Näytä kartalla” -toimintoa käytettiin {{map}} kertaa.",
      "sub": {
        "season": "Kausi",
        "content": "Sisältö",
        "nearby": "Lähistöllä",
        "sponsors": "Sponsorit"
      },
      "selectRiver": "Valitse joki",
      "systemPlacesNote": "Koskee kaikkia jokia: {{system}}. Lisää paikka kerran, niin se näkyy kaikilla joilla.",
      "sponsorReportEmpty": "Ei vielä sponsoreita. Kohdassa ”Lähistöllä” voit merkitä kohteen ”Tukee jokea (sponsori)”. Sponsorit näkyvät silloin tässä klikkauksineen kuukaudessa.",
      "placeFamily": "Koko perheelle (myös ei-kalastajille)",
      "placePhone": "Puhelin",
      "placeImage": "Kuva (sponsori)",
      "sponsorTier_none": "Ei sponsoria",
      "sponsorTier_friend": "Joen ystävä",
      "sponsorTier_local": "Paikallinen tuki",
      "sponsorTier_supporter": "Tukija",
      "sponsorTier_partner": "Kumppani",
      "sponsorTier_main": "Pääsponsori"
    },
    "valds": {
      "title": "Kalastusalueet",
      "ownerLabel": "Omistaja",
      "noOwner": "Ei omistajaa",
      "assignOwner": "Vaihda omistaja",
      "clearOwner": "Poista omistaja",
      "searchUsers": "Hae käyttäjää (nimi tai sähköposti)…"
    },
    "messaging": {
      "title": "Lähetä viesti",
      "recipients": "Vastaanottajat",
      "recipientValdeiere": "Kalastusalueiden omistajat",
      "recipientFishers": "Kalastajat",
      "recipientAll": "Kaikki",
      "subject": "Aihe",
      "body": "Viesti",
      "send": "Lähetä viesti",
      "sending": "Lähetetään…",
      "sent": "Lähetetty {{count}} vastaanottajalle",
      "sentCount": "Lähetetty",
      "history": "Lähetetyt viestit",
      "empty": "Ei lähetetty viestejä vielä",
      "recipientCustom": "Yksittäiset henkilöt",
      "emailToggle": "Lähetä myös sähköpostilla ({{count}} sähköpostilla)",
      "previewCount": "{{count}} vastaanottajaa",
      "noRecipients": "Vastaanottajia ei löydy",
      "sendBtn": "Lähetä {{count}} vastaanottajalle"
    }
  },
  "notifications": {
    "title": "Ilmoitukset",
    "markAllRead": "Merkitse kaikki luetuiksi",
    "empty": "Ei ilmoituksia",
    "typeMessageReceived": "Uusi viesti",
    "typeValdOwnerAssigned": "Kalastusalue osoitettu"
  },
  "common": {
    "loading": "Ladataan…",
    "noResults": "Ei tuloksia",
    "error": "Jokin meni pieleen",
    "retry": "Yritä uudelleen",
    "kg": "kg",
    "cm": "cm",
    "back": "Takaisin",
    "clear": "Tyhjennä",
    "delete": "Poista",
    "paymentMethods": "Hyväksymme Vipps, kortin (Visa/Mastercard) ja MobilePayn.",
    "cancel": "Peruuta",
    "save": "Tallenna",
    "previousMonth": "Edellinen kuukausi",
    "nextMonth": "Seuraava kuukausi"
  },
  "auth": {
    "loginRequired": "Kirjaudu sisään jatkaaksesi",
    "loginForCatch": "Kirjaudu sisään rekisteröidäksesi saaliin",
    "loginForMyCatches": "Kirjaudu sisään nähdäksesi saaliisi",
    "loginForProfile": "Kirjaudu sisään nähdäksesi profiilisi",
    "loginHint": "Voit kirjautua Googlella, sähköpostilinkillä tai salasanalla",
    "registerHint": "Uusi käyttäjä?",
    "registerLink": "Luo tili"
  },
  "history": {
    "title": "Saalishistoria",
    "year": "Vuosi",
    "week": "Viikko",
    "weekLabel": "Viikko {{week}}",
    "allWeeks": "Kaikki viikot",
    "colTime": "Aika",
    "colFish": "Kalajaji",
    "colWeight": "Paino",
    "colLength": "Pituus",
    "colGear": "Pyydys",
    "colVald": "Vald",
    "colFisher": "Kalastaja",
    "colReleased": "Vapautettu"
  },
  "valdPage": {
    "river": "Joki",
    "owner": "Omistaja",
    "noOwner": "Ei saatavilla",
    "catchesThisYear": "Saaliit tänä vuonna",
    "fiskekortTitle": "Kalastusluvat",
    "noFiskekort": "Ei kalastuslupia tälle alueelle",
    "loginToBook": "Kirjaudu sisään ostaaksesi kalastusluvan",
    "buy": "Osta",
    "price": "Hinta",
    "durationDay": "{{count}} päivä",
    "durationDays": "{{count}} päivää",
    "seasonLabel": "Kausi",
    "unlimited": "Rajoittamaton",
    "available": "Saatavilla",
    "remaining": "{{count}} jäljellä",
    "soldOut": "Loppuunmyyty",
    "seasonOpens": "Kausi avautuu {{date}}",
    "seasonEnded": "Kausi on päättynyt",
    "preBook": "Ennakkovaraus",
    "packagesTitle": "Paketit",
    "noPackages": "Ei paketteja saatavilla",
    "packageIncludes": "Sisältää",
    "combinedPrice": "Yhdistetty hinta: {{price}} kr",
    "orderPackageBtn": "Tilaa paketti",
    "accommodationTitle": "Majoitus",
    "accommodationNoCardRequired": "Kalastuslupaa ei tarvita – kaikki voivat varata majoituksen.",
    "noAccommodation": "Ei majoitusta saatavilla",
    "capacity": "{{count}} henkilö",
    "capacity_plural": "{{count}} henkilöä",
    "perNight": "/ yö",
    "book": "Varaa majoitus",
    "accommodationType_hytte": "Mökki",
    "accommodationType_rom": "Huone",
    "accommodationType_telt": "Telttapaikka",
    "accommodationType_campingvogn": "Asuntovaunu",
    "accommodationType_annet": "Muu",
    "omOssTitle": "Meistä",
    "contactPhone": "Puhelin",
    "contactEmail": "Sähköposti",
    "contactWebsite": "Verkkosivusto",
    "tilgjengelighet": "Saavutettavuus",
    "avstandBilvei": "Etäisyys tielle",
    "editVald": "Muokkaa aluetta",
    "fishingSpotsTitle": "Kalastuspaikat",
    "seePermits": "Näytä kalastuslupa"
  },
  "fiskekort": {
    "purchaseTitle": "Osta kalastuslupa",
    "product": "Tuote",
    "vald": "Alue",
    "validFrom": "Ensimmäinen päivä",
    "validTo": "Voimassa",
    "price": "Hinta",
    "confirm": "Vahvista osto",
    "submitting": "Ostetaan…",
    "success": "Kalastuslupa ostettu!",
    "successDescription": "Lupa on nyt voimassa.",
    "viewMyCards": "Katso omat luvat",
    "currency": "NOK",
    "paymentProcessing": "Käsitellään maksua…",
    "paymentCancelled": "Maksu peruutettu",
    "paymentCancelledDesc": "Voit yrittää ostaa luvan uudelleen.",
    "paymentPending": "Maksu vastaanotettu",
    "paymentPendingDesc": "Odotamme vahvistusta maksuntarjoajalta. Lupasi näkyy Kalastuslupani-osiossa vahvistuksen jälkeen.",
    "seasonNote": "Kausi: {{open}} – {{close}}",
    "errorBeforeSeason": "Valittu päivä on kauden ulkopuolella. Kausi alkaa {{open}}.",
    "errorAfterSeason": "Lupa ylittää kauden päättymisspäivän ({{close}}). Valitse aikaisempi aloitusspäivä.",
    "disinfectionTitle": "Desinfiointi (pakollinen)",
    "disinfectionHint": "Tämä joki edellyyttää, että vahvistat välineidesi ja/tai veneesi desinfioinnin säädösten mukaisesti.",
    "disinfectionRequired": "Sinun on valittava desinfiointimenetelmä.",
    "disinfectionMethod": {
      "dried_2weeks": "Kuivattu vähintään 2 viikkoa",
      "frozen": "Jäädytetty",
      "heat_treated": "Kuumennuskäsitelty (vähintään 60 °C)",
      "chemical": "Kemiallisesti desinfioitu"
    },
    "quantity": "Lupien määrä",
    "totalPrice": "Kokonaishinta"
  },
  "myFiskekort": {
    "title": "Omat kalastusluvat",
    "empty": "Sinulla ei ole vielä kalastuslupia.",
    "validFrom": "Alkaen",
    "validTo": "Päättyy",
    "status": "Tila",
    "status_confirmed": "Aktiivinen",
    "status_cancelled": "Peruutettu",
    "status_pending": "Odottaa",
    "vald": "Alue",
    "product": "Tyyppi",
    "price": "Maksettu",
    "bookAgain": "Varaa uudelleen →",
    "showProof": "Näytä todistus",
    "registerCatch": "Rekisteröi saalis"
  },
  "myBookings": {
    "title": "Omat varaukset",
    "empty": "Sinulla ei ole vielä varauksia.",
    "listing": "Majoitus",
    "checkIn": "Saapuminen",
    "checkOut": "Lähtö",
    "guests": "Vieraat",
    "total": "Yhteensä",
    "status_confirmed": "Vahvistettu",
    "status_cancelled": "Peruutettu",
    "status_pending": "Odottaa",
    "cancelBtn": "Peruuta varaus",
    "cancelConfirm": "Oletko varma, että haluat peruuttaa tämän varauksen?",
    "cancelling": "Peruutetaan…",
    "cancelError": "Peruutus epäonnistui. Yritä uudelleen.",
    "refundNote": "Varaus peruutettu. Mahdollinen palautus käsitellään manuaalisesti 5 arkipäivän kuluessa."
  },
  "valdAdmin": {
    "title": "Alueen hallinta",
    "myValds": "Omat alueet",
    "selectVald": "Valitse alue hallittavaksi",
    "searchVald": "Hae aluetta…",
    "catchesThisYear": "Saaliit tänä vuonna",
    "totalCatches": "Saaliit yhteensä",
    "fiskekortTitle": "Kalastusluvat",
    "addProduct": "Lisää lupa",
    "editProduct": "Muokkaa",
    "deactivateProduct": "Poista käytöstä",
    "noProducts": "Ei kalastuslupia määritetty",
    "description": "Kuvaus",
    "savedDescription": "Tallennettu!",
    "saveDescription": "Tallenna kuvaus",
    "purchasesTitle": "Myydyt luvat",
    "noPurchases": "Ei myyntejä vielä",
    "productName": "Nimi",
    "productPrice": "Hinta (øre)",
    "productDuration": "Kesto (päiviä)",
    "productSeasonStart": "Kauden alku (YYYY-MM-DD)",
    "productSeasonEnd": "Kauden loppu (YYYY-MM-DD)",
    "productQuota": "Kiintiö (tyhjjä = rajoittamaton)",
    "save": "Tallenna",
    "cancel": "Peruuta",
    "saving": "Tallennetaan…",
    "confirmDeactivate": "Poista tämä tuote käytöstä?",
    "confirmForceDeleteProduct": "Tuotteella on vahvistettuja ostoja. Poistetaanko pysyvästi (mukaan lukien kaikki ostot)? Tätä ei voi peruuttaa.",
    "purchaseFisher": "Kalastaja",
    "purchaseProduct": "Tuote",
    "purchaseValid": "Voimassa",
    "purchaseStatus": "Tila",
    "purchasePaid": "Maksettu",
    "backToValds": "Takaisin aluelistaan",
    "viewPublicPage": "Näytä julkinen sivu",
    "tabFiskekort": "Kalastusluvat",
    "tabAccommodation": "Majoitus",
    "tabPackages": "Paketit",
    "tabSettings": "Asetukset",
    "tabRevenue": "Tulot",
    "addListing": "Lisää majoitus",
    "editListing": "Muokkaa",
    "deactivateListing": "Poista käytöstä",
    "activateListing": "Aktivoi",
    "managePhotos": "Kuvat",
    "addPhoto": "Lisää kuva",
    "deletePhoto": "Poista kuva",
    "uploadingPhoto": "Ladataan...",
    "confirmDeletePhoto": "Poistetaanko tämä kuva?",
    "noListings": "Ei majoitustarjouksia vielä",
    "listingName": "Nimi",
    "listingType": "Tyyppi",
    "listingCapacity": "Kapasiteetti (henkilöt)",
    "listingPrice": "Hinta per yö (øre)",
    "listingDesc": "Kuvaus",
    "listingProximityNote": "Etäisyys kalastuspaikalle",
    "listingProximityNotePlaceholder": "esim. 5 min ajomatka vyöhykkeeltä 2",
    "listingOpenFrom": "Auki alkaen (KK-PP)",
    "listingOpenTo": "Auki saakka (KK-PP)",
    "listingMinNights": "Min. yötä",
    "listingMaxNights": "Max. yötä",
    "blockedPeriods": "Estetyt jaksot",
    "noBlockedPeriods": "Ei estettyjä jaksoja.",
    "addBlockedPeriod": "Lisää esto",
    "blockedFrom": "Alkaen",
    "blockedTo": "Saakka",
    "blockedReason": "Syy (valinnainen)",
    "blockedReasonHint": "esim. Huolto",
    "bookingsTitle": "Varauskyselyt: {{name}}",
    "noBookings": "Ei varauskyselytä",
    "bookingGuest": "Vieras",
    "bookingDates": "Päivämäärät",
    "bookingStatus": "Tila",
    "bookingConfirm": "Vahvista",
    "bookingCancel": "Hylkää",
    "bookingStatus_pending": "Odottaa",
    "bookingStatus_confirmed": "Vahvistettu",
    "bookingStatus_cancelled": "Hylätty",
    "addPackage": "Lisää paketti",
    "editPackage": "Muokkaa",
    "deletePackage": "Poista",
    "noPackages": "Ei paketteja vielä",
    "packageName": "Nimi",
    "packageDesc": "Kuvaus",
    "packageFiskekort": "Kalastuslupa (valinnainen)",
    "packageAccommodation": "Majoitus (valinnainen)",
    "packageCombinedPrice": "Yhdistetty hinta øre (valinnainen)",
    "packageNone": "— ei mitään —",
    "contactTitle": "Yhteystiedot (Meistä)",
    "contactName": "Nimi / organisaatio",
    "contactPhone": "Puhelin",
    "contactEmail": "Sähköposti",
    "contactWebsite": "Verkkosivusto",
    "saveContact": "Tallenna yhteystiedot",
    "fishingOptionsTitle": "Kalastusvaihtoehdot",
    "suitableForFlyFishing": "Sopii perhokalastukseen",
    "fishingFromBoat": "Venealastusvaihtoehdot saatavilla",
    "saveFishingOptions": "Tallenna kalastusvaihtoehdot",
    "seasonPicker": {
      "yearRound": "Koko kausi",
      "yearRoundNote": "Saatavilla koko vuoden",
      "selectStart": "Valitse aloituspaiva",
      "selectEnd": "valitse lopetuspaiva"
    },
    "calendarPreview": "Näytä kalenterin esikatselu",
    "calendarPreviewHide": "Piilota kalenterin esikatselu",
    "setupChecklist": {
      "title": "Aloita – aseta vald",
      "step1": "Kuvaile vald",
      "step2": "Lisää kalastuslupa-tuote",
      "step3": "Lisää majoitus",
      "step4": "Luo paketti",
      "optional": "valinnainen",
      "packageHint": "Luo kalastuslupa-tuote ja majoitusvaihtoehto ennen paketin luomista."
    }
  },
  "accommodation": {
    "bookTitle": "Varaa majoitus",
    "listing": "Majoitus",
    "checkIn": "Sisäänkirjautuminen",
    "checkOut": "Uloskirjautuminen",
    "guestCount": "Vieraiden määrä",
    "guestName": "Nimesi",
    "guestEmail": "Sähköposti",
    "guestPhone": "Puhelin (valinnainen)",
    "notes": "Viesti omistajalle (valinnainen)",
    "totalPrice": "Kokonaishinta",
    "totalNights": "{{count}} yö",
    "totalNights_plural": "{{count}} yötä",
    "bookBtn": "Lähetä varauskyselyt",
    "submitting": "Lähetetään…",
    "success": "Kysely lähetetty!",
    "successDetail": "Omistaja ottaa yhteyttä vahvistaakseen.",
    "loginRequired": "Sinun täytyy kirjautua sisään varataksesi majoituksen",
    "perNight": "/ yö",
    "datesUnavailable": "Nämä päivämäärät eivät ole saatavilla, valitse muut päivämäärät",
    "paymentProcessing": "Käsitellään maksua…",
    "paymentConfirmed": "Maksu vahvistettu!",
    "paymentConfirmedDesc": "Varauksesi on vahvistettu. Tervetuloa!",
    "paymentCancelled": "Maksu peruutettu",
    "paymentCancelledDesc": "Maksu peruutettiin. Voit yrittää uudelleen.",
    "paymentPending": "Maksu odottaa",
    "paymentPendingDesc": "Maksua ei ole vielä vahvistettu. Tarkista Varaukseni pian.",
    "viewMyBookings": "Katso varaukset",
    "unavailablePeriods": "Varatut ajanjaksot",
    "blockedPeriods": "Estetyt ajanjaksot",
    "seasonWindow": "Kausi auki {{from}} – {{to}}",
    "minNightsHint": "Vähintään {{count}} yötä",
    "maxNightsHint": "Enintään {{count}} yötä",
    "minNightsError": "Vähintään {{count}} yötä vaaditaan",
    "maxNightsError": "Enintään {{count}} yötä sallittu",
    "outsideSeason": "Valitut päivämäärät ovat sesongin ulkopuolella"
  },
  "fiskekortList": {
    "title": "Saatavilla olevat kalastuskortit",
    "intro": "Selaa ja osta kalastuskortteja",
    "noProducts": "Kalastuskortteja ei ole saatavilla tällä hetkellä",
    "buy": "Osta",
    "soldOut": "Loppuunmyyty",
    "unlimited": "Rajoittamaton",
    "remaining": "{{count}} jäljellä",
    "durationDay": "1 päivä",
    "durationDays": "{{count}} päivää",
    "calendarView": "Kalenteri",
    "listView": "Lista",
    "noProductsDay": "Kalastuskortteja ei ole saatavilla tänä päivänä",
    "legendAvailable": "Saatavilla",
    "legendSoldOut": "Loppuunmyyty"
  },
  "fishingDay": {
    "title": "Kirjaa kalastuspäivä",
    "intro": "Rekisteröi, että olet kalastanut tänään ilman saaliita.",
    "submit": "Kirjaa kalastuspäivä",
    "submitting": "Kirjataan…",
    "success": "Kalastuspäivä kirjattu!",
    "successCta": "Haluatko rekisteröidä saaliin?",
    "calendarTitle": "Kalastuspäiväsi",
    "noCatches": "ei saalista",
    "catchCount_one": "{{count}} saalis",
    "catchCount_other": "{{count}} saalista",
    "delete": "Poista",
    "confirmDelete": "Poistetaanko tämä kalastuspäivä?"
  },
  "contact": {
    "title": "Ota yhteyttä",
    "intro": "Onko sinulla kysyttavää tai palautetta? Lähetä meille viesti, niin vastaamme mahdollisimman pian.",
    "name": "Nimi",
    "email": "Sähköpostiosoite",
    "message": "Viesti",
    "send": "Lähetä viesti",
    "sending": "Lähetetään...",
    "successMessage": "Kiitos! Olemme vastaanottaneet viestisi ja vastaamme pian.",
    "errorMessage": "Jokin meni pieleen. Yritä uudelleen."
  },
  "revenue": {
    "title": "Tulot",
    "year": "Vuosi",
    "fiskekortTotal": "Kalastusluvat",
    "bookingsTotal": "Majoitus",
    "grandTotal": "Yhteensä",
    "fiskekortSales": "Myydyt kalastusluvat",
    "accommodationBookings": "Majoitusvaraukset",
    "noData": "Ei tietoja valitulle vuodelle.",
    "exportCsv": "Lataa CSV",
    "product": "Tuote",
    "date": "Päivämäärä",
    "amount": "Määrä",
    "listing": "Kohde",
    "checkIn": "Sisäänkirjautuminen",
    "checkOut": "Uloskirjautuminen",
    "guest": "Vieras",
    "payoutStatus": "Maksettu",
    "payoutDone": "Kyllä",
    "payoutPending": "Ei"
  },
  "packageOrder": {
    "title": "Tilaa paketti",
    "priceBreakdown": "Hinnan erittely",
    "fiskekortPart": "Kalastuslupa",
    "accommodationPart": "Majoitus",
    "combinedTotal": "Yhteishinta",
    "validFrom": "Luvan alkaminen (sisäänkirjautuminen)",
    "checkIn": "Sisäänkirjautuminen",
    "checkOut": "Uloskirjautuminen",
    "guestCount": "Vieraiden lukumäärä",
    "guestName": "Nimesi",
    "guestEmail": "Sähköposti",
    "guestPhone": "Puhelin (valinnainen)",
    "notes": "Viesti (valinnainen)",
    "submitBtn": "Tilaa ja maksa",
    "submitting": "Lähetetään…",
    "paymentProcessing": "Käsitellään maksua…",
    "paymentConfirmed": "Paketti tilattu!",
    "paymentConfirmedDesc": "Kalastuslupa ja majoitus vahvistettu. Hyvää kalastusta!",
    "paymentPending": "Maksu odottaa",
    "paymentPendingDesc": "Maksua ei ole vielä vahvistettu. Tarkista Omat tilaukset hetken kuluttua.",
    "paymentCancelled": "Maksu peruttu",
    "paymentCancelledDesc": "Voit yrittää uudelleen.",
    "viewMyBookings": "Näytä varaukseni",
    "loginRequired": "Sinun täytyy kirjautua sisään tilataksesi paketin"
  },
  "riverPage": {
    "notFound": "Jokea ei löydy",
    "temporarilyClosed": "Tilapäisesti suljettu",
    "requiresDisinfection": "Desinfiointi vaaditaan",
    "packagesSection": "Paketit — kalastuslupa + majoitus",
    "valdsSection": "Kalastusalueet ja kalastusluvat",
    "accommodationSection": "Majoitus",
    "viewVald": "Näytä alue",
    "noValds": "Alueita ei rekisteröity",
    "noProductsForVald": "Lupia ei saatavilla",
    "mapSection": "Joen kartta",
    "fishingRulesTitle": "Kalastussäännöt",
    "eventsSection": "Mitä kauden aikana tapahtuu",
    "staySection": "Majoitu, syö ja koe: {{name}}",
    "readMore": "Lue lisää",
    "placeCategory_hotel": "Hotelli",
    "placeCategory_restaurant": "Ravintola",
    "placeCategory_camping": "Leirintäalue",
    "placeCategory_cabin": "Mökit",
    "placeCategory_shop": "Kauppa",
    "placeCategory_other": "Muu",
    "filterValds": "Hae valdeja…",
    "noValdMatch": "Mikään vald ei vastaa hakua",
    "fromPrice": "alk. {{price}}",
    "cardCount_one": "{{count}} lupa",
    "cardCount_other": "{{count}} lupaa",
    "noCardsAvailable": "Ei lupia saatavilla",
    "showAllValds": "Näytä kaikki {{count}} valdia",
    "seePermits": "Näytä kalastuslupa",
    "nearbyFilter_all": "Kaikki",
    "nearbyFilter_stay": "Majoitus",
    "nearbyFilter_eat": "Ruoka",
    "nearbyFilter_shop": "Kaupat",
    "nearbyFilter_other": "Muut",
    "nearbyNear": "Lähinnä",
    "nearbyNearNone": "Ei valintaa",
    "nearbyDistance": "{{km}} km linnuntietä paikasta {{vald}}",
    "nearbyBookable": "Varattavissa täällä",
    "nearbyAd": "Sponsoroitu sisältö",
    "nearbyTag_fiskekort": "Myy kalastuslupia",
    "nearbyTag_tackle": "Kalastusvälineet",
    "nearbyTag_guide": "Opas",
    "nearbyTag_boat": "Veneenvuokraus",
    "nearbyTag_drying": "Kuivaushuone",
    "nearbyTag_freezer": "Pakastin",
    "nearbyTag_earlyBreakfast": "Aikainen aamiainen",
    "mapLayer_valds": "Valdit",
    "mapLayer_spots": "Kalapaikat",
    "nearbySponsor": "Tukee: {{river}}",
    "nearbyPick": "Jokiosakaskunnan suosittelema",
    "nearbyShowOnMap": "Näytä kartalla",
    "sponsorsRow": "Tukijat",
    "placeCategory_attraction": "Nähtävyys",
    "nearbyFilter_see": "Elämykset",
    "nearbyFilter_family": "Perhe",
    "nearbyFamily": "Koko perheelle",
    "nearbyVisit": "Käy verkkosivulla",
    "nearbyCall": "Soita",
    "sponsorMain": "Pääsponsori"
  },
  "fiskekortBevis": {
    "statusActive": "Voimassa — lupa on voimassa",
    "refLabel": "Viite",
    "print": "Tulosta / Jaa",
    "catchCtaText": "Saaliit? Muista rekisteröidä saaliisi!",
    "catchCtaBtn": "Rekisteröi saalis"
  },
  "discovery": {
    "title": "Etsi kalastuslupia Norjan lohijokiin",
    "intro": "Selaa kalastusalueita ja osta kalastuslupia omistajilta, jotka myyvät Lakseborsenin kautta. Suodata joen, kalastustekniikan tai saatavuuden mukaan.",
    "filterRiver": "Suodata joen mukaan",
    "allRivers": "Kaikki joet",
    "flyFishing": "Perhokalastus",
    "boatFishing": "Venekalastus",
    "hasFiskekort": "Kalastuslupa",
    "clearFilters": "Tyhjennä suodattimet",
    "resultCount": "{{count}} kalastusvettä",
    "noResults": "Mikään kalastusvesi ei vastaa suodatinta.",
    "buyFiskekort": "Osta lupa",
    "seeVald": "Katso kalastusvesi",
    "searchPlaceholder": "Hae kalastusvettä tai jokea",
    "sortLabel": "Järjestä",
    "sortName": "Nimi (A-Ö)",
    "sortPrice": "Hinta"
  },
  "bliValdeier": {
    "title": "Ryhdy killan omistajaksi",
    "lead": "Sinut on kutsuttu killan omistajaksi alueelle {{valdName}} joella {{riverName}}.",
    "vald": "Kilta",
    "river": "Joki",
    "loginHint": "Kirjaudu sisään kutsuttuun sähköpostiin rekisteröidyllä tilillä hyväksyäksesi.",
    "loginAndAccept": "Kirjaudu ja hyväksy",
    "autoClaimHint": "Rekisteröintiä viimeistellään…",
    "claiming": "Omistajuutta rekisteröidään…",
    "successTitle": "Tervetuloa killan omistajaksi!",
    "successDesc": "Sinut on nyt rekisteröity {{valdName}} omistajaksi.",
    "goToValdAdmin": "Siirry kilta-adminiin",
    "notFoundTitle": "Kutsua ei löydy",
    "notFoundDesc": "Linkki on virheellinen tai vanhentunut.",
    "expiredTitle": "Kutsu on vanhentunut",
    "expiredDesc": "Pyydä ylläpitäjää lähettämään uusi kutsu.",
    "claimedTitle": "Jo käytetty",
    "claimedDesc": "Tämä kutsu on jo hyväksytty.",
    "errorTitle": "Jotain meni pieleen"
  },
  "komIGang": {
    "selectVald": "Valitse kilta",
    "chooseVald": "Valitse kilta",
    "step1Title": "Yhteystiedot",
    "step1Desc": "Syötä yhteystiedot ja kuvaus killasta. Tämä näytetään julkisesti.",
    "contactName": "Yhteyshenkilö",
    "contactNamePlaceholder": "Nimi tai organisaatio",
    "phone": "Puhelin",
    "email": "Sähköposti",
    "website": "Verkkosivusto",
    "description": "Kuvaus",
    "descriptionPlaceholder": "Kerro killasta, kalastusolosuhteista, säännöistä jne.",
    "step2Title": "Kartta ja kalastustavat",
    "step2Desc": "Sijoita kilta kartalle, piirrä rajat ja valitse kalastustekniikat.",
    "mapLocation": "Karttasijainti (klikkaa sijoittaaksesi)",
    "polygon": "Killan raja (valinnainen)",
    "flyFishing": "Soveltuu perhokalastukseen",
    "boatFishing": "Kalastus veneestä mahdollista",
    "step3Title": "Kalapaikat",
    "step3Desc": "Lisää tiettyjä kalapaikkoja kartalle (valinnainen).",
    "step3Hint": "Voit lisätä kalapaikkoja kilta-adminpaneelista milloin tahansa.",
    "back": "Takaisin",
    "nextStep": "Seuraava askel",
    "skipWizard": "Ohita",
    "goToValdAdmin": "Siirry kilta-adminiin"
  },
  "installPrompt": {
    "text": "Lisää Lakseborsen aloitusnäytölle nopeampaa käyttöä varten",
    "iosHint": "Lisää Lakseborsen aloitusnäytölle: avaa selaimen Jaa-valikko ja valitse ”Lisää Koti-valikkoon”.",
    "install": "Lisää",
    "dismiss": "Sulje"
  },
  "textSize": {
    "label": "Tekstin koko",
    "normal": "Normaali tekstikoko",
    "large": "Suuri tekstikoko",
    "xlarge": "Erittäin suuri tekstikoko"
  },
  "statsSection": {
    "title": "Tilastot ja kaaviot",
    "yearLabel": "Kausi",
    "tooFewData": "Tämän tilaston näyttämiseen tarvitaan lisää dataa",
    "noCatchesForYear": "Ei rekisteröityjä saaliita tällä kaudella",
    "loading": "Ladataan tilastoja…",
    "axisCatches": "Saaliit",
    "axisAvgWeight": "Keskipaino (kg)",
    "axisWeek": "Viikko",
    "axisHour": "Tunti",
    "kpi": {
      "totalCatches": "Saaliiden määrä",
      "totalWeight": "Kokonaispaino",
      "avgWeight": "Keskipaino",
      "biggestFish": "Suurin kala",
      "releaseRate": "Vapautettujen osuus",
      "uniqueAnglers": "Aktiiviset kalastajat",
      "cpue": "Saalis per kalastaja",
      "fishingHours": "Kalastustunnit",
      "catchesPerHour": "Saalis tunnissa",
      "anglersNow": "Kalastajia nyt"
    },
    "fishType": {
      "title": "Jakauma kalalajeittain",
      "subtitle": "Saaliiden määrä lajeittain"
    },
    "gear": {
      "title": "Mikä väline saa eniten saalista?",
      "subtitle": "Saaliit välinetyypeittäin"
    },
    "weekly": {
      "title": "Milloin kaudella kalastus on parasta?",
      "subtitle": "Saaliit viikoittain"
    },
    "hour": {
      "title": "Mihin aikaan päivästä kala syö?",
      "subtitle": "Saaliit tunneittain"
    },
    "airTemp": {
      "title": "Ilman lämpötila ja saalis",
      "subtitle": "Saaliiden määrä ja keskipaino lämpötilan mukaan"
    },
    "waterTemp": {
      "title": "Veden lämpötila ja saalis",
      "subtitle": "Saaliiden määrä ja keskipaino lämpötilan mukaan"
    },
    "waterFlow": {
      "title": "Vedenkorkeus ja saalis",
      "subtitle": "Saaliiden määrä ja keskipaino virtaamatason mukaan"
    },
    "historicalHeader": "Historiallinen yleiskatsaus",
    "yearly": {
      "title": "Saaliit kausittain",
      "subtitle": "Rekisteröityjen saaliiden kokonaismäärä vuosittain"
    },
    "typical": {
      "title": "Tyypillinen kausi vs. tämä vuosi",
      "subtitle": "Viikkokeskiarvo perustuen {{yearCount}} historialliseen kauteen",
      "avgLabel": "Keskiarvo",
      "currentLabel": "{{year}}"
    },
    "biggest": {
      "title": "Kaikkien aikojen suurimmat saaliit",
      "subtitle": "Top 10 — napsauta nähdäksesi saaliin"
    },
    "showAllCharts": "Näytä kaikki kaaviot"
  },
  "notFound": {
    "title": "Sivua ei löytynyt",
    "message": "Emme löytäneet etsimääsi sivua.",
    "backHome": "Etusivulle"
  },
  "terms": {
    "title": "Kalastusehdot",
    "accept": "Olen lukenut ja hyväksyn ehdot",
    "mustAccept": "Sinun on hyväksyttävä ehdot jatkaaksesi.",
    "translationNote": "Tämä on käännös. Ristiriitatilanteessa norjankielinen teksti on ensisijainen.",
    "noticeTitle": "Kalastusehdot vesistöalueella",
    "noticeBody": "Tälle vesistöalueelle on asetettu kalastusehdot, etkä ole vielä hyväksynyt niitä. Ne koskevat sinua riippumatta siitä, mistä ostit kalastusluvan. Voit silti rekisteröidä saaliisi.",
    "readAndAccept": "Lue ja hyväksy ehdot",
    "acceptNow": "Hyväksyn ehdot",
    "acceptFailed": "Hyväksynnän tallennus epäonnistui. Yritä uudelleen."
  },
  "checkin": {
    "intro": "Kalastatko nyt? Aloita kalastus, jotta jokiyhdistys näkee, kuinka paljon kalastusaikaa saaliiden takana on.",
    "start": "Aloita kalastus nyt",
    "end": "Kalastus päättynyt",
    "active": "Kalastat kohteessa {{vald}}",
    "endFailed": "päättäminen epäonnistui",
    "pickVald": "Valitse ensin vald alta.",
    "privacy": "Tallennamme vain ajankohdat, emme sijaintiasi.",
    "sessions": {
      "title": "Kalastuskertasi",
      "intro": "Unohditko painaa ”Aloita kalastus” tai ”Kalastus päättynyt”? Lisää tai korjaa kerta tässä. Ajat ovat itse ilmoitettuja, ja voit lisätä kertoja viimeisten 60 päivän ajalta (enintään 14 tuntia kerrallaan).",
      "empty": "Ei vielä kalastuskertoja.",
      "add": "Lisää kalastuskerta",
      "edit": "Muokkaa",
      "delete": "Poista",
      "confirmDelete": "Poistetaanko tämä kalastuskerta?",
      "vald": "Vald",
      "start": "Alku",
      "end": "Loppu",
      "save": "Tallenna",
      "cancel": "Peruuta",
      "running": "Käynnissä",
      "unknown": "Kesto tuntematon: korjaa kalastuskerta",
      "manual": "lisätty käsin",
      "hm": "{{h}} t {{m}} min",
      "errors": {
        "end_before_start": "Lopun on oltava alun jälkeen.",
        "too_long": "Kalastuskerta voi olla enintään 14 tuntia.",
        "in_future": "Ajankohta ei voi olla tulevaisuudessa.",
        "too_old": "Voit lisätä kalastuskertoja vain viimeisten 60 päivän ajalta.",
        "overlap": "Tämä kalastuskerta menee päällekkäin toisen kalastuskertasi kanssa.",
        "open_session": "Päätä kalastuskerta painikkeella ”Kalastus päättynyt”.",
        "end_required": "Anna, milloin kalastuskerta päättyi.",
        "vald_not_found": "Valdia ei löytynyt.",
        "generic": "Kalastuskerran tallennus epäonnistui. Yritä uudelleen."
      }
    }
  },
  "elvekort": {
    "notFound": "Elvekortia ei löytynyt.",
    "voluntary": "Elvekort on vapaaehtoinen. Et tarvitse sitä kalastusluvan ostamiseen tai saaliin ilmoittamiseen.",
    "buy": "Osta elvekort",
    "validPeriod": "Voimassa {{from}} – {{to}}",
    "myCards": "Omat elvekortit",
    "offerTitle": "Elvekort vesistöalueelle",
    "confirmedTitle": "Elvekort ostettu",
    "cancelledTitle": "Maksu peruutettiin",
    "processing": "Käsitellään maksua…",
    "pendingHint": "Maksua ei ole vielä vahvistettu. Tarkista ”Omat elvekortit” hetken kuluttua."
  },
  "riversPage": {
    "metaTitle": "Joet ja vuokra-alueet – lohijoet Norjassa | Lakseborsen",
    "metaDescription": "Yleiskatsaus lohijokiin ja vuokra-alueisiin: kalastuskortit, kausi ja majoitus.",
    "title": "Joet ja vuokra-alueet",
    "intro": "Kaikki Lakseborsenin joet ja niiden vuokra-alueet. Valitse joki nähdäksesi kauden, säännöt, majoituksen ja lähellä olevat ruokapaikat.",
    "closed": "Tilapäisesti suljettu",
    "valds": "Vuokra-alueet",
    "seeRiver": "Katso {{river}}",
    "aboutRiver": "Tietoa joesta",
    "valdsCount": "{{count}} vuokra-aluetta"
  }
}
